import { useSelector } from "react-redux";
import { getAllMetricsRequest } from "../store/selectors/dashboardSelectors";
import { REQUEST_PENDING, REQUEST_UNCALLED } from "../constants/request";

const useAllMetricsRequestPending = () =>
  [REQUEST_PENDING, REQUEST_UNCALLED].includes(useSelector(getAllMetricsRequest));

export default useAllMetricsRequestPending;
